import { render, staticRenderFns } from "./RepeaterSectionForm.vue?vue&type=template&id=c584a72a"
import script from "./RepeaterSectionForm.vue?vue&type=script&lang=js"
export * from "./RepeaterSectionForm.vue?vue&type=script&lang=js"
import style0 from "./RepeaterSectionForm.vue?vue&type=style&index=0&id=c584a72a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports